import {environment} from '../../environments/environment';
import {TableQueryInterface} from "../components/table-customized/models/table-query.interface";
import Swal from "sweetalert2";
import {ElementRef} from "@angular/core";

export class AppHelper {

    static  async Wait(ms) {
        return new Promise(resolve => {
            setTimeout(resolve, ms);
        });
    }

    static RemoveSkinClasses(element: HTMLBodyElement) {

      for (let className of Array.from(element.classList)) {

        if (className.endsWith("-skin")) {

          element.classList.remove(className);
        }
      }
    }

    static DevPrint(data: any) {

      if (!environment.production) {

        if (typeof data === 'string') {

          console.warn(data);
        } else {

          console.warn(data?.error ? data.error.detail : data.message);
        }

      }
    }

    static ShowAlertError(titulo, mensaje, e?, allowEnterKey = true) {

        console.error( ( environment.production || !e ) ? mensaje : e);

        // @ts-ignore
        return Swal.fire({
            title: titulo,
            icon: 'error',
            text: ( environment.production || !e ) ? mensaje :
              ( (e.error && e.error.detail) ? e.error.detail : e.message ) + ' (' + mensaje + ')',
            showCancelButton: false,
            confirmButtonText: 'Ok',
            allowEnterKey
        });
    }

    static ShowAlertSuccess(titulo, mensaje, html = false) {

        // @ts-ignore
        return Swal.fire({
            title: titulo,
            icon: 'success',
            [html ? 'html' : 'text']: mensaje,
            showCancelButton: false,
            confirmButtonText: 'Ok'
        });
    }

    public static PaginationToQueryString(pagination?: TableQueryInterface, textField = 'text') {

      if (pagination) {

        const qa = [ 'pageable=1' ];

        if (pagination.page) {

          qa.push(`page=${encodeURIComponent(pagination.page)}`);
        }

        if (pagination.itemByPage) {

          qa.push(`pagination=${encodeURIComponent(pagination.itemByPage)}`);
        }

        if (pagination.text) {

          qa.push(`${textField}=${encodeURIComponent(pagination.text)}`);
        }

        if (pagination.orderBy && pagination.orderBy.length) {

          pagination.orderBy.forEach((obj: { field: string, order: 'asc' | 'desc' }) => {

            if (obj.field && obj.order) {

              let field = obj.field;
              qa.push(`${encodeURIComponent('order[' + field + ']')}=${obj.order}`);
            }
          });
        }

        return qa.join('&');
      }

      return '';
    }

    /**
     * Permite obtener el valor en un json desde el path de la propiedad.
     * Por ejemplo: path = 'estado.nombre' devuelve el valor Object['estado']['nombre']
     *
     * @param object
     * @param path
     */
    static ValueFromPath(object: any, path: string) {

      if (!path || !object) {

        return null;
      }

      const fields = path.split('.');

      let value = object;
      for (let f of fields) {

        if (!value[f]) {

          return value[f];
        }

        value = value[f];
      }

      return value;
    }

    static HorizontalScrollStep(el: ElementRef): { width: number, maxWidth: number, step: number, scrollStep: number } {

      const width = el?.nativeElement.clientWidth || 1;
      const maxWidth = el?.nativeElement.scrollWidth || 1;
      const step = Math.floor(maxWidth/width) + 1;

      return { width, maxWidth, step, scrollStep: Math.floor(maxWidth / step)};
    }

    public static Tree(data: any[], root) {

      const t1 = root ? ( data.find(d => d.id == root) || {} ) : {};

      t1.children = [];

      const children = data.filter( d =>  (!root && !d.parent) || (root && d.parent == root) );

      children.forEach(r => {

        t1.children.push(AppHelper.Tree(data, r.id));
      });

      t1.children = t1.children.sort( (a, b) => a.position < b.position ? -1: 1);

      return t1;
    }

    static FormatFromColumn(value: any, columns: any[], locale: string): any {

        columns?.forEach(c => {

            if ( ! value[c.keyword] ) {

                return;
            }

            switch (c.formato) {
                case 'number':
                    //Parametrizar c.decimales
                    value[c.keyword] = AppHelper.FormatNumber(value[c.keyword], locale,2, 'decimal');
                    break;
                case 'percent':
                    value[c.keyword] = AppHelper.FormatNumber(value[c.keyword] / 100, locale, c.decimales, 'percent');
                    break;
                case 'date':
                    value[c.keyword] = value[c.keyword] ? (new Date(value[c.keyword])).toLocaleString(locale) : ''
                    break;
            }

        });

        return value;
    }

    static FormatNumber(number, locale = 'en-US', decimals = null, style: any = null, currency: string = null) {

        const options: any = style ? { style } : {};

        if (decimals) {

            options.maximumFractionDigits = decimals;
            options.minimumFractionDigits = decimals;
            options.useGrouping = true;
        }

        if (currency) {

            options.currency = currency;
            options.currencyDisplay = 'narrowSymbol';
        }

        return new Intl.NumberFormat(locale, options).format(number);
    }

}
